import styled from "@emotion/styled";
import { OnComputerWritingFormat } from "api/planning";
import { Label } from "semantic-ui-react";

type Props = {
  onComputerWritingFormats: OnComputerWritingFormat[]
}

export const OnComputerWritingFormatBadges = ({ onComputerWritingFormats }: Props) => {
  let isOnComputerWritingFormat = onComputerWritingFormats?.includes(OnComputerWritingFormat.OnComputer) ?? false;
  let isOnPaperWritingFormat = onComputerWritingFormats?.includes(OnComputerWritingFormat.OnPaper) ?? false;

  return <>
    {isOnComputerWritingFormat && <OnComputerLabel>CD</OnComputerLabel>}
    {isOnPaperWritingFormat && <OnPaperLabel>+P</OnPaperLabel>}
  </>;

};

export const OnComputerLabel = styled(Label)`
    &.ui.label {
      background: #e9f9ed !important;
      color: #188F35 !important;
      margin-left: 0;
      margin-right: 0.25rem;
    }
  `;

export const OnPaperLabel = styled(Label)`
    &.ui.label {
      background: #74bc86 !important;
      color: #ffffff !important;
      margin-left: 0;
    }
  `;
